// Constants for different requests for current reducer
export default {
  notifications: 'NOTIFICATIONS',
};
